/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2022-07-07 11:49:52
 * @LastEditors: linxi
 * @LastEditTime: 2024-09-02 18:15:54
 */
import {
  CaretDownFilled,
  CloseOutlined,
  SettingOutlined,
} from '@ant-design/icons'
import { unwrapResult } from '@reduxjs/toolkit'
import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  Modal,
  notification,
  Radio,
  Row,
  Select,
} from 'antd'
import TextArea from 'antd/lib/input/TextArea'
import moment from 'moment'
import React, { useContext, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { RootDispatch } from '../../../app/store'
import { DiseaseInput } from '../../../compnents/input/DiseaseInput'
import {
  DateTimeFormat,
  DateTimeFormatMessageSimple,
} from '../../../models/datetime'
import { getOrgaztionnName } from '../../../models/notifiction'
import { ThemeContext } from '../../../theme/ThemeContext'
import { getLabelList } from '../../tenant/tenantSlice'
import styles from './notification.module.css'
import {
  getDetailData,
  getNotificationCenterSubmit,
} from './notificationCenterSlice'

export const NotifictionModal = (props: {
  isModalVisible: boolean
  messageId: any
  onOk: () => void
  onCancel: () => void
}) => {
  const dispatch = useDispatch<RootDispatch>()

  const [form] = Form.useForm()

  const { RangePicker } = DatePicker

  const theme = useContext(ThemeContext)

  const [selectedOrgazations, setSelectedOrgazations] = useState<any[]>([]) //接受机构为指定机构时的列表的机构名称们

  const [acceptOrgazation, setAcceptOrgazation] = useState<any>() //详情接受机构的字段

  const [tenantIdList, setTenantIdList] = useState<any>() //编辑时传的值

  const [isOnlyOrgaztionEmpty, setIsOnlyOrgaztionEmpty] = useState(false)

  const [detailData, setDetailData] = useState<any>()

  const [labelList, setLabelList] = useState<any>([]) //标签数据

  const [submitLoading, setSubmitLoading] = useState(false)

  const labelData = () => {
    dispatch(
      getLabelList({
        current: 1,
        size: 1000,
      })
    )
      .then(unwrapResult)
      .then((res) => setLabelList(res.records))
  }

  // 指定机构时的传参
  useEffect(() => {
    if (selectedOrgazations) {
      setTenantIdList(selectedOrgazations?.map((v) => v?.id))
    }
  }, [selectedOrgazations])

  // 详情接口
  useEffect(() => {
    labelData()
    if (props?.messageId) {
      dispatch(getDetailData({ id: props?.messageId }))
        .then(unwrapResult)
        .then((v: any) => {
          setDetailData(v)
          setSelectedOrgazations(
            v &&
              v?.tenantIdList?.map((v: any) => {
                return { name: v?.tenantName, id: v?.tenantId }
              })
          )
        })
    } else {
      setDetailData({})
      form.resetFields()
    }
  }, [props?.messageId, props?.isModalVisible])

  // 接收机构下拉框非指定机构时的展示
  useEffect(() => {
    if (acceptOrgazation != 2 && acceptOrgazation != 3) {
      setSelectedOrgazations(
        acceptOrgazation
          ? [{ name: getOrgaztionnName(String(acceptOrgazation)) }]
          : []
      )
    }
  }, [acceptOrgazation])

  //数据编辑时回填
  useEffect(() => {
    if (props?.isModalVisible) {
      if (detailData && props?.messageId) {
        setAcceptOrgazation(detailData?.flag?.toString())
        if (detailData?.flag == 3) {
          setSelectedOrgazations([])
        }
        form.setFieldsValue({
          ...detailData,
          flag: detailData?.flag?.toString(),
          tenantIdList: detailData?.labelId?.map((item: any) => item.id),
          time: [
            moment(detailData?.effectiveTime) || '',
            moment(detailData?.expirationTime) || '',
          ],
        })
      }
    } else {
      setSelectedOrgazations([])
    }
  }, [detailData, props?.messageId, props?.isModalVisible])

  return (
    <Modal
      width={800}
      title={props?.messageId ? '编辑通知' : '新增通知'}
      visible={props.isModalVisible}
      onOk={() => {
        props.onOk()
        form.resetFields()
        setSelectedOrgazations([])
        setAcceptOrgazation('')
      }}
      onCancel={() => {
        props.onCancel()
        form.resetFields()
        setSelectedOrgazations([])
        setAcceptOrgazation('')
      }}
      footer={null}
    >
      <Form
        // {...layout}
        autoComplete='off'
        form={form}
        onFinish={(fs) => {
          const editParam = {
            ...detailData,
            ...fs,
            time: undefined,
            effectiveTime: fs?.time?.[0]?.format(DateTimeFormatMessageSimple),
            expirationTime: fs?.time?.[1]?.format(DateTimeFormatMessageSimple),
            messageId: props?.messageId,
            tenantIdList:
              fs?.flag == 2
                ? tenantIdList
                : fs?.flag == 3
                ? fs.tenantIdList
                : undefined,
          }
          if (props?.messageId) {
            setSubmitLoading(true)
            dispatch(getNotificationCenterSubmit({ ...editParam }))
              .then(unwrapResult)
              .then(() => {
                notification.success({
                  message: '操作成功',
                })
                props.onOk()
                form.resetFields()
                setSelectedOrgazations([])
                setAcceptOrgazation('')
                setSubmitLoading(false)
              })
              .catch(() => {
                props.onCancel()
                form.resetFields()
                setSelectedOrgazations([])
                setAcceptOrgazation('')
                setSubmitLoading(false)
              })
          } else {
            setSubmitLoading(true)
            dispatch(
              getNotificationCenterSubmit({
                ...editParam,
                messageId: undefined,
              })
            )
              .then(unwrapResult)
              .then(() => {
                notification.success({
                  message: '操作成功',
                })
                props.onOk()
                form.resetFields()
                setSelectedOrgazations([])
                setAcceptOrgazation('')
                setSubmitLoading(false)
              })
              .catch(() => {
                props.onCancel()
                form.resetFields()
                setSelectedOrgazations([])
                setAcceptOrgazation('')
                setSubmitLoading(false)
              })
          }
        }}
      >
        <Row>
          <Col span={24}>
            <Form.Item
              label='消息标题'
              name='title'
              rules={[
                {
                  required: true,
                  message: '请输入消息标题',
                },
                ({ getFieldValue }) => ({
                  validator: (_, start) => {
                    const reg = /[~@#$%^&*<>]/g /*定义验证表达式*/
                    if (reg.test(start)) {
                      return Promise.reject('您输入的内容中包含非法特殊字符')
                    } else {
                      return Promise.resolve()
                    }
                  },
                }),
              ]}
            >
              <Input placeholder='请输入' maxLength={15} />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label='消息内容'
              name='content'
              rules={[
                {
                  required: true,
                  message: '请输入消息内容',
                },
                ({ getFieldValue }) => ({
                  validator: (_, start) => {
                    const reg = /[~@#$%^&*<>]/g /*定义验证表达式*/
                    if (reg.test(start)) {
                      return Promise.reject('您输入的内容中包含非法特殊字符')
                    } else {
                      return Promise.resolve()
                    }
                  },
                }),
              ]}
            >
              <TextArea placeholder='请输入' showCount maxLength={500} />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label='追加链接'
              name='url'
              style={{ marginLeft: '10px' }}
              // rules={[
              //   {
              //     pattern: /(http|https):\/\/([\w.]+\/?)\S*/,
              //     message: '请输入正确的url',
              //   },
              // ]}
            >
              <Input placeholder='例：http://www.baidu.com' />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label='内部链接'
              name='innerUrl'
              style={{ marginLeft: '10px' }}
            >
              <Input placeholder='例：http://www.baidu.com' />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              label='接收机构'
              name='flag'
              style={{ marginRight: '10px' }}
              rules={[
                {
                  required: true,
                  message: '请选择接收机构！',
                },
              ]}
            >
              <Select
                allowClear
                placeholder='请选择机构'
                onChange={(v: any) => {
                  setAcceptOrgazation(v)
                  if (v == 2 || v == 3) {
                    setSelectedOrgazations([])
                  }
                }}
              >
                <Select.Option value={'0'}>所有机构</Select.Option>
                <Select.Option value={'1'}>医保机构</Select.Option>
                <Select.Option value={'2'}>指定机构</Select.Option>
                <Select.Option value={'3'}>按标签</Select.Option>
              </Select>
            </Form.Item>
          </Col>
          {acceptOrgazation == 2 && (
            <Col span={12}>
              <Form.Item
                name='tenantIdList'
                rules={
                  selectedOrgazations?.length != 0
                    ? []
                    : [
                        {
                          max: 500,
                          required: true,
                          message: '请输入机构名称!',
                        },
                        // () => ({
                        //   validator: () => {
                        //     if (isOnlyOrgaztionEmpty) {
                        //       return Promise.reject('请输入机构名称')
                        //     }
                        //     return Promise.resolve()
                        //   },
                        // }),
                      ]
                }
              >
                <DiseaseInput
                  NoticeTag={true}
                  placeholder='请输入机构名称以检索'
                  onChange={() => setIsOnlyOrgaztionEmpty(false)}
                  onSelect={(disease) => {
                    if (
                      !selectedOrgazations.find(
                        (d: any) => d?.id === disease?.id
                      )
                    ) {
                      setSelectedOrgazations(
                        selectedOrgazations.concat(disease)
                      )
                      form.resetFields(['tenantIdList'])
                    }
                  }}
                />
              </Form.Item>
            </Col>
          )}
          {selectedOrgazations?.length != 0 && (
            <Col
              span={24}
              style={{
                borderRadius: 2,
                border: `1px solid ${theme.wbd}`,
                padding: '5px 5px 0 5px',
                marginRight: 10,
                marginBottom: 23,
              }}
            >
              {selectedOrgazations.map((d: any) => (
                <div key={d.id} className={styles.disease}>
                  {`${d.name}`}
                  {acceptOrgazation == 2 && (
                    <CloseOutlined
                      style={{ cursor: 'pointer' }}
                      onClick={() => {
                        setSelectedOrgazations(
                          acceptOrgazation == 2
                            ? selectedOrgazations.filter(
                                (i: any) => i?.id !== d?.id
                              )
                            : selectedOrgazations.filter((i: any) => i !== d)
                        )
                      }}
                    />
                  )}
                </div>
              ))}
            </Col>
          )}

          {acceptOrgazation == 3 && (
            <Col span={12}>
              <Form.Item
                name='tenantIdList'
                rules={[
                  {
                    required: true,
                    message: '请选择标签！',
                  },
                ]}
              >
                <Select
                  mode='tags'
                  suffixIcon={<CaretDownFilled style={{ color: theme.tc3 }} />}
                  placeholder='标签-全部'
                  allowClear
                  style={{ width: '100%' }}
                >
                  {labelList.map((c: any) => (
                    <Select.Option key={c.id} value={c.id}>
                      {c.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          )}
          <Col span={24}>
            <Form.Item
              label='通知生效时间'
              name='time'
              style={{ marginRight: '10px' }}
              rules={[
                {
                  required: true,
                  message: '请选择生效时间',
                },
              ]}
            >
              <RangePicker showTime />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label='通知类型'
              name='messageType'
              style={{ marginRight: '10px' }}
              rules={[
                {
                  required: true,
                  message: '请选择通知类型',
                },
              ]}
            >
              <Radio.Group>
                <Radio value={0}> 普通通知 </Radio>
                <Radio value={1}> 紧急通知（强提醒） </Radio>
                <Radio value={2}> 弹窗通知（谨慎选择） </Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
          <Row gutter={20} style={{ width: '100%', justifyContent: 'end' }}>
            <Button
              type='primary'
              loading={submitLoading}
              onClick={() => form.submit()}
              // htmlType='submit'
            >
              创建通知
            </Button>
          </Row>
        </Row>
      </Form>
    </Modal>
  )
}
